/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Values_Save_ChangesInputs */

const en_case_values_save_changes = /** @type {(inputs: Case_Values_Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

const pt_br2_case_values_save_changes = /** @type {(inputs: Case_Values_Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações`)
};

/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Case_Values_Save_ChangesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_values_save_changes = /** @type {((inputs?: Case_Values_Save_ChangesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Values_Save_ChangesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_values_save_changes(inputs)
	return pt_br2_case_values_save_changes(inputs)
});